import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

import { SCHEDULE_HOUR_LABEL_MOBILE_FORMAT } from '../constants';
import {
  WEEKLY_SCHEDULE_TIME_CELL_SX,
  WEEKLY_SCHEDULE_TIME_LABEL_SX,
  WEEKLY_SCHEDULE_TIME_TICK_SX,
} from '../styles';
import { getScheduleHourLabels } from '../utils/general';

export default function ScheduleTimeColumn() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box>
      {getScheduleHourLabels(isMobile ? SCHEDULE_HOUR_LABEL_MOBILE_FORMAT : undefined).map(
        (label) => (
          <Box key={label} sx={WEEKLY_SCHEDULE_TIME_CELL_SX}>
            <Typography component="span" sx={WEEKLY_SCHEDULE_TIME_LABEL_SX}>
              {label}
            </Typography>
            <Box sx={WEEKLY_SCHEDULE_TIME_TICK_SX} />
          </Box>
        ),
      )}
    </Box>
  );
}
